import { render, staticRenderFns } from "./AssetTypeSelect2.vue?vue&type=template&id=8e8bffe4&"
import script from "./AssetTypeSelect2.vue?vue&type=script&lang=js&"
export * from "./AssetTypeSelect2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
